import React from "react";
import CountUp from "react-countup";
import "./newhome.css";

const StatsSection2 = () => {
  return (
    <section className="home2-stats-section">

      <div className="home2-stat-box">
        <h2>
          
          <CountUp end={1} duration={4} />
          Lakh
        </h2>
        <p>Active Properties</p>
      </div>

      <div className="home2-stat-box">
        <h2>
          <CountUp end={25 } duration={4} />
          Crore
        </h2>
        <p>Inactive Property</p>
      </div>

      <div className="home2-stat-box">
        <h2>
          <CountUp end={20} duration={4} />
          + 
        </h2>
        <p>Cities</p>
      </div>

      <div className="home2-stat-box">
        <h2>
          <CountUp end={1600} duration={4} decimals={0} />
          +
        </h2>
        <p>Localities</p>
      </div>

    </section>
  );
};

export default StatsSection2;